import { useEffect } from "react";
import { useNavigate } from "react-router";
import axios from "axios";

function ExcelDownload(props)
{
    const navigate = useNavigate();

      useEffect(() => {

        axios.post('https://nodeppcbackend-production.up.railway.app/api/generateExcel', {

                Stage:props.stage.toString(), 
                Username: "",
                Signature: ""        
            })
        .then((response) => {
            
           //console.log(response.data);
           //setCompetitorData(response.data)
            if(response.data === "Done!")
            {
            axios.get('https://nodeppcbackend-production.up.railway.app/api/downloadExcel', {
                timeout:4000,
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }}).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Rezultate_' + props.stage.toString() + '.xlsx'); 
                    document.body.appendChild(link);
                    link.click();
                   
                })

                navigate("/Admin/Dashboard");
            }
            else
            {
                alert("Erorare la generarea fisierului excel!");
            }
                
           
        }).catch((error) => console.log("Error"));

    }, [])


    return(
        <div className="container" style={{width:'500px', marginTop: "20vh", marginLeft: "-10vw"}}>
           
        </div>

    );
}

export default ExcelDownload;

